module.exports = __webpack_public_path__ + "static/media/colocacion_placas_tauroc.63d98e24.jpg";